import type { ReactNode } from 'react';

export function MiniSection({ title, action, children }: { title: string; action?: ReactNode; children: ReactNode }): JSX.Element {
  return (
    <section className="rounded border border-ink-100 bg-ink-50/60 p-2 space-y-1.5">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-ink-500">{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
}
